import * as React from "react";
import { Card, Icon } from "antd";
import { NavLink } from "react-router-dom";
import IfAuthenticated from "src/components/IfAuthenticated";
export interface Props {
  children?: React.ReactNode;
}

export interface State {}

export default class Home extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <>
        <IfAuthenticated scope="nextcloud">
          <a href="https://cloud.jugendgrossweikersdorf.at" target="_blank">
            <Card
              style={{ width: 300, marginTop: 16 }}
              actions={[<Icon key={1} type="export" />]}
            >
              JG NextCloud
            </Card>
          </a>
        </IfAuthenticated>

        <NavLink to="/me">
          <Card
            style={{ width: 300, marginTop: 16 }}
            actions={[<Icon key={1} type="export" />]}
          >
            My Account
          </Card>
        </NavLink>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Home/Home.tsx